import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfLobControlService } from '../../../Conf-Shared/Services/conf-lob-service/conf-lob-control.service';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { lastValueFrom, take } from 'rxjs';
import { getAllState } from '../../../../configurator-app/conf-store/reducer';
import { CookieService } from 'ngx-cookie-service';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { redirectTo } from '../../../../configurator-app/conf-utility/conf-configuration';
(pdfMake as any).vfs = pdfFonts.pdfMake?.vfs;

import { RootService } from '../../../../shared/services/root.service'; //for osp team
import { resetAllState } from '../../../../configurator-app/conf-store/action';
import { environment } from '../../../../../environments/environment.prod';

import { vc_data } from '../../pdf/vehicle_data';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-conf-nav-header',
  templateUrl: './conf-nav-header.component.html',
  styleUrls: ['./conf-nav-header.component.scss']
})
export class ConfNavHeaderComponent implements OnInit {
  confAWSUrlStr: any = environment.confAWSurl;
  navHeaderTitle: any;
  showSaveModalStatus: boolean = false
  showGroupIcons: boolean = false;
  postSubscribe: any = new Subscription;
  ospWishlistApi: any = new Subscription
  sharePostdatetime: Subscription = new Subscription();
  name_of_pdf: any
  userData: any;
  configurator_id: string = "";
  downloadIcon: any = this.confAWSUrlStr + "/common/download.png";
  disableBtn: any = false;
  @Input() buildHeaderState : boolean = true

  //for osp team below contsructor
  constructor(private secureService: RootService, private _dataLobService: ConfLobControlService, private router: Router, private store: Store, private cookie_service: CookieService, private toaster: ToastrService) { }
  //constructor(private _dataLobService: ConfLobControlService, private router: Router, private store: Store, private cookie_service: CookieService) { }

  ngOnDestroy(): void {
    if (this.postSubscribe) {
      this.postSubscribe.unsubscribe()
    }

    if (this.ospWishlistApi) {
      this.ospWishlistApi.unsubscribe()
    }
  }

  vehicle_booking_amount: any
  ngOnInit(): void {
    this.postSubscribe = this._dataLobService.sharePostdatetime.subscribe((data: any) => {
      this.vehicle_booking_amount = data[0]['Vehicle Booking Amount']
    });
    this.userData = this.secureService.getUserData(); //for osp team

    this.store.pipe(select(getAllState)).subscribe((state: any) => {
      this.showGroupIcons = false
      if (state.stepBarState.currentStep == (Number(state.stepBarState.stepArr.length) - 1) || !this.buildHeaderState) {
        this.showGroupIcons = true
      }
    })
    // select(getAllState).
    let current_router = this.router.url
    let router_arr = current_router.split("/");

    if (router_arr[2] == "hcv") {
      this.navHeaderTitle = 'HCV Configurator'
    }
    else if (router_arr[2] == "scv") {
      this.navHeaderTitle = 'SCV Configurator'
    }
    else if (router_arr[2] == "bus") {
      this.navHeaderTitle = 'Bus Configurator'
    }
    else if (router_arr[2] == "winger") {
      this.navHeaderTitle = 'WINGER Configurator'
    }
    else if (router_arr[2] == "magic") {
      this.navHeaderTitle = 'MAGIC Configurator'
    }
    else if (router_arr[2] == "ilmcv") {
      this.navHeaderTitle = 'ILMCV Configurator'
    }

    this.name_of_pdf = router_arr[2] + '_' + Date.now() + '.pdf'
  }

  routeToHome() {
    let conf_id = this.cookie_service.get("configuration_id");
    if (conf_id != "" && conf_id != undefined && conf_id != null) {
      this.cookie_service.set("configuration_id", "")
    }
    this.store.dispatch(resetAllState())
    this.router.navigateByUrl('/' + redirectTo);
  }

  routeToOSP() {
    let conf_id = this.cookie_service.get("configuration_id");
    if (conf_id != "" && conf_id != undefined && conf_id != null) {
      this.cookie_service.set("configuration_id", "")
    }
    this.store.dispatch(resetAllState())
    this.router.navigateByUrl('/home');
  }

  saveSelections() {
    this.showSaveModalStatus = true
  }

  async saveConfSelection() {
    const promise = new Promise(async (res: any, rej: any) => {
      let state = await lastValueFrom(this.store.pipe(select(getAllState), take(1)));
      let postPayload: any = {}

      let conf_id = this.cookie_service.get("configuration_id");

      if (conf_id == "" || conf_id == undefined) {
        postPayload['configuration_id'] = ""
      } else {
        postPayload['configuration_id'] = conf_id
      }

      let stateObj: any = {};
      stateObj['stepState'] = state.stepBarState;
      stateObj['lobDataState'] = state.lobDataState;

      postPayload['last_visited_step_json'] = JSON.stringify(stateObj)

      if (state.stepBarState.selectedConfLob === 'magic')
        postPayload['lob'] = 'tata_magic'
      else
        postPayload['lob'] = state.stepBarState.selectedConfLob

      let currentStep = state.stepBarState['currentStep'];
      let currentStepTitle = state.stepBarState.stepArr[currentStep].title

      // postPayload['vc_no'] = '123' //Need to remove once mandator vc column removed from table
      if (currentStepTitle === 'Summary') {
        postPayload['vc_no'] = state.lobDataState.selectedVCNumber[state.stepBarState.selectedConfLob];
      } else {
        postPayload['vc_no'] = null
      }

      postPayload['source'] = "configurator"

      //Will be changed with osp code token fetch
      // let authToken: any = bearerToken.token
      let authToken: any = this.cookie_service.get("access_token") // OSP team


      // /*
      this.postSubscribe = this._dataLobService.getConfDataAuthenticate("add_user_activity", postPayload, authToken).subscribe((result: any) => {
        if (result['RESPONSE']['STATUS_CODE'] == 200) {
          let configurator_id = result['RESPONSE']['Configuration_Id']


          if (conf_id == "" || conf_id == undefined || conf_id == null) {
            this.cookie_service.set("configuration_id", configurator_id)
          }

          //OSP Code
          this.toaster.success("Configurator saved successfully " + configurator_id)
          res();
        }
      },
        error => {
          this.disableBtn = false;
          this.downloadIcon = this.confAWSUrlStr + "/common/download.png"
        }

      )

      this.showSaveModalStatus = false
    })

    return promise;
  }

  Postdata: any;
  Postdata_2: any
  Postdata_3: any
  vc_name: any
  vc_image: any
  vasPlanDetail: any;
  background_image: any
  logo_image: any
  configuration_data: any = []
  vehicle_data: any = []
  value_added_services: any = []
  final_price_details: any = []
  vehicle_vcno: any = '';
  dummy_vc: any = '';

  async download() {
    if (this.disableBtn) return
    this.disableBtn = true;
    this.downloadIcon = this.confAWSUrlStr + "/common/download_loader.gif"

    //Function call for save/edit configuration id
    let promiseCall = await this.saveConfSelection();

    this.configurator_id = this.cookie_service.get("configuration_id")

    // Generate Date
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var d = new Date();
    var day = days[d.getDay()];
    var hr = d.getHours();
    let min: any = d.getMinutes();
    if (min < 10) {
      min = "0" + min;
    }
    var ampm = "PM";
    if (hr < 12) {
      ampm = "AM";
    }
    var date = d.getDate();
    var month = months[d.getMonth()];
    var year = d.getFullYear();
    var x = document.getElementById("time");

    let full_date = date + " " + month + " " + year + " & " + day + " " + hr + ":" + min + " " + ampm;

    this.configuration_data = []
    this.vehicle_data = []
    this.value_added_services = []
    this.final_price_details = []

    /*====================================================================================*/

    let state = await lastValueFrom(this.store.pipe(select(getAllState), take(1)));
    let data: any = state.stepBarState.stepArr
    let index = data.findIndex((x: { title: string; }) => x.title === 'Base Vehicle');
    this.vc_name = data[index].value

    /*====================================================================================*/

    // Configuration Details
    let obj: any = {}
    for (let x = 0; x < data.length; x++) {
      if (data[x].title == 'Additional Features' || data[x].title == 'Base Vehicle') {
        continue;
      }
      const element = data[x].title;
      obj[element] = data[x].value;
    }
    obj['Vehicle Description'] = data[index].value
    delete obj['Summary'];
    delete obj['Value Added Services'];
    for (const [key, value] of Object.entries(obj)) {
      let obj = { title: key, value: value }
      this.configuration_data.push(obj)
    }

    /*====================================================================================*/

    if (state.stepBarState.selectedConfLob === 'scv') {
      this.Postdata = {}
      this.Postdata["lob_name"] = state.stepBarState.selectedConfLob
      this.Postdata["output_type"] = "all"
      this.Postdata["application"] = state.stepBarState.stepArr[0].value
      this.Postdata["expected_kms"] = state.stepBarState.stepArr[1].value.substr(0, (state.stepBarState.stepArr[1].value.length - 8))
      this.Postdata["loading_length"] = state.stepBarState.stepArr[2].value
      this.Postdata["body_type"] = state.stepBarState.stepArr[3].value
      this.Postdata['vc_no'] = data[index].other
      this.vehicle_booking_amount = 5000
      this.dummy_vc = '55378720ACNR';
    }
    else if (state.stepBarState.selectedConfLob === 'winger') {
      this.Postdata = {}
      this.Postdata["lob_name"] = "winger"
      this.Postdata["output_type"] = "all",
        this.Postdata['application'] = state.stepBarState.stepArr[0].value
      this.Postdata['wheelbase'] = state.stepBarState.stepArr[1].value
      this.Postdata['body_type'] = state.stepBarState.stepArr[2].value
      this.Postdata['comfort'] = state.stepBarState.stepArr[3].value
      this.Postdata['roof_type'] = state.stepBarState.stepArr[4].value
      this.Postdata["passenger_capacity"] = state.stepBarState.stepArr[5].value
      this.Postdata['vc_no'] = data[index].other
      this.vehicle_booking_amount = 5000
      this.dummy_vc = '55378720ACNR';
    }
    else if (state.stepBarState.selectedConfLob === 'magic') {
      this.Postdata = {}
      this.Postdata["lob_name"] = "tata_magic"
      this.Postdata["output_type"] = "all"
      this.Postdata["roof_type"] = state.stepBarState.stepArr[0].value
      this.Postdata["fuel_type"] = state.stepBarState.stepArr[1].value
      this.Postdata["application"] = state.stepBarState.stepArr[2].value
      this.Postdata['vc_no'] = data[index].other
      this.vehicle_booking_amount = 5000
      this.dummy_vc = '55378720ACNR';
    }
    else if (state.stepBarState.selectedConfLob === 'hcv' || state.stepBarState.selectedConfLob === 'ilmcv') {
      this.vehicle_booking_amount = 10000
      var currentStateArr = state.stepBarState.stepArr;
      let otherDetails = state.stepBarState.lobVehicleData.vehLxData

      let additionFeaturePageNo = currentStateArr.findIndex((step: any) => step.title === "Additional Features");
      let comfort_select = "";
      if (additionFeaturePageNo > 0) {
        comfort_select = state.stepBarState.stepArr[additionFeaturePageNo].value
      }

      if (state.stepBarState.selectedConfLob === 'hcv') {
        this.dummy_vc = '50852155000R';
      }
      else {
        this.dummy_vc = '55326533000R';
      }

      this.Postdata = {}
      this.Postdata["lob_name"] = state.stepBarState.selectedConfLob
      this.Postdata["output_type"] = "all"
      this.Postdata['vc_no'] = data[index].other
      this.Postdata['vc_desc'] = data[index].value

      if (comfort_select == 'Selected') {
        this.Postdata['vc_no'] = otherDetails.vc_no
        this.Postdata['vc_desc'] = otherDetails.vc_desc
      }

    }
    else {
      this.dummy_vc = '41069462000R';
      this.vehicle_booking_amount = 10000
      this.Postdata = {}
      this.Postdata["lob_name"] = state.stepBarState.selectedConfLob
      this.Postdata["output_type"] = "all"
      this.Postdata['vc_no'] = data[index].other
      this.Postdata['vc_desc'] = data[index].value
    }

    if (environment.ProdSandboxLink) {
      this.vehicle_vcno = this.Postdata['vc_no'];
    } else {
      this.vehicle_vcno = this.dummy_vc
    }

    this._dataLobService.getLobFilterData('osp_configurator_lob_filter', this.Postdata).subscribe(async (result: any) => {

      // Vehicle Details
      let obj = vc_data(result['RESPONSE']['DATA'][0], state.stepBarState.selectedConfLob)
      for (const [key, value] of Object.entries(obj)) {
        let key_: any = key;
        let value_: any = value;

        if (key == 'Engine') {
          value_ = value_.replaceAll('<br>', " ")
        }

        let obj = { title: key_, value: value_ }
        this.vehicle_data.push(obj)
      }

      if (state.stepBarState.selectedConfLob == 'hcv') {
        let descp_title_index = this.configuration_data.findIndex((ob: any) => ob.title === "Vehicle Description");
        this.configuration_data[descp_title_index]['value'] = result['RESPONSE']['DATA'][0]['vc_anaplan']
      }
      else if (state.stepBarState.selectedConfLob == 'ilmcv') {
        let descp_title_index = this.configuration_data.findIndex((ob: any) => ob.title === "Vehicle Description");
        this.configuration_data[descp_title_index]['value'] = result['RESPONSE']['DATA'][0]['vc_desc']
      }

      /*====================================================================================*/

      // VAS Price Details
      this.vasPlanDetail = "";
      let currentStateArr = state.stepBarState.stepArr;
      let vasPageNo = currentStateArr.findIndex((step: any) => step.title === "Value Added Services");

      if (vasPageNo > 0 || vasPageNo !== -1) {
        if (currentStateArr[vasPageNo].value === 'Selected') {
          this.vasPlanDetail = state.stepBarState.stepArr[vasPageNo].other

          let vasYear = (parseInt(this.vasPlanDetail['vasNumOfYears']) / 12);
          let vasYearString = ""

          if (vasYear == 1) {
            vasYearString = vasYear + " Year"
          } else {
            vasYearString = vasYear + " Years"
          }

          let vas_price_obj: any = {}
          vas_price_obj['VAS Plan'] = this.vasPlanDetail['vasPackage']
          vas_price_obj['Terrain'] = this.vasPlanDetail['vasTerrain']
          vas_price_obj['Annual Kms'] = this.vasPlanDetail['vasAnnualKms'] + " Kms"
          vas_price_obj['No. Of Years'] = vasYearString
          vas_price_obj['Application'] = this.vasPlanDetail['vasApplication']
          for (const [key, value] of Object.entries(vas_price_obj)) {
            if (value == undefined) continue
            let obj = { title: key, value: value }
            this.value_added_services.push(obj)
          }
        }

      }

      /*====================================================================================*/

      // Final Price Details
      let final_price_obj: any = {}
      let total_amt;
      if (this.vasPlanDetail === undefined || this.vasPlanDetail === '') {
        total_amt = 0 + Number(this.vehicle_booking_amount);
      } else {
        total_amt = Number(this.vasPlanDetail['vasBookingAmount']) + Number(this.vehicle_booking_amount);
        final_price_obj['VAS Booking Amount'] = '₹ ' + this.vasPlanDetail['vasBookingAmount']
      }
      final_price_obj['Vehicle Booking Amount'] = '₹ ' + Number(this.vehicle_booking_amount)
      final_price_obj['Net Order Price'] = '₹ ' + await this.getprice(this.vehicle_vcno)
      final_price_obj['Total Booking Amount'] = '₹ ' + total_amt
      for (const [key, value] of Object.entries(final_price_obj)) {
        let obj = { title: key, value: value }
        this.final_price_details.push(obj)
      }

      /*====================================================================================*/

      // Tata Motors Logo
      this.logo_image = await this.getBase64ImageFromURL(this.confAWSUrlStr + '/common/tmlhdlogo.png')
      this.background_image = await this.getBase64ImageFromURL(this.confAWSUrlStr + '/common/bgpdf.jpg')

      // VC IMAGE
      let base64_img = await this.getimg(state.stepBarState.selectedConfLob, data[index].other)
      let vcimage_ = await this.getBase64ImageFromURL(base64_img)
      let vcimage;

      if (vcimage_ === 'invalid') {
        vcimage = await this.getBase64ImageFromURL(this.confAWSUrlStr + '/common/not_found.png')
      } else {
        vcimage = vcimage_
      }

      let pdf_data: any;
      if (this.value_added_services.length > 0) {
        pdf_data = await this.pdfdata_with_VAS(this.logo_image, this.configuration_data, this.value_added_services, this.vehicle_data, this.final_price_details, full_date, this.background_image, vcimage)
      } else {
        pdf_data = await this.pdfdata_without_VAS(this.logo_image, this.configuration_data, this.vehicle_data, this.final_price_details, full_date, this.background_image, vcimage)
      }
      pdfMake.createPdf(pdf_data).download(this.name_of_pdf);

      var that = this
      setTimeout(function () {
        that.disableBtn = false;
        that.downloadIcon = that.confAWSUrlStr + "/common/download.png"
      }, 3000)

    })

  }

  getimg(lob: any, vc_number: any) {
    return new Promise(resolve => {
      this.Postdata_2 = {}
      this.Postdata_2["lob"] = lob;
      this.Postdata_2["vc_number"] = vc_number;
      this._dataLobService.getLobFilterData('osp_configurator_get_images', this.Postdata_2).subscribe(async (res: any) => {
        resolve(res['RESPONSE']['DATA']['exteriorImage'][0])
      }, (error) => (
        resolve(this.confAWSUrlStr + '/common/not_found.png')
      ))
    })
  }

  getprice(vc_number: any) {
    return new Promise(resolve => {
      this.Postdata_3 = {}
      this.Postdata_3["vc_number"] = vc_number;
      this._dataLobService.getLobFilterData('get_vc_exshowroom_price', this.Postdata_3).subscribe((res: any) => {
        if (res['RESPONSE']['DATA']['vc_exshowroom_price'] === null) {
          resolve(0)
        } else {
          resolve(res['RESPONSE']['DATA']['vc_exshowroom_price'])
        }
      }, (error) => (
        resolve(0)
      ))
    })
  }

  async pdfdata_with_VAS(img: any, data: any, data2: any, data3: any, data4: any, full_date: any, img2: any, img3: any) {
    let rect = {
      type: 'rect',
      x: 0, y: 0, w: 250, h: 32,
      linearGradient: ['#090B60', '#ffffff'],
    };
    let rect2 = {
      type: 'rect',
      x: 0, y: 0, w: 500, h: 32,
      linearGradient: ['#090B60', '#e0e4e9'],
    };
    let rect3 = {
      type: 'rect',
      x: 0, y: 0, w: 500, h: 32,
      linearGradient: ['#090B60', '#e0e4e9'],
    };
    let rect4 = {
      type: 'rect',
      x: 0, y: 0, w: 500, h: 32,
      linearGradient: ['#090B60', '#e0e4e9'],
    };
    let rect5 = {
      type: 'rect',
      x: 0, y: 0, w: 500, h: 32,
      linearGradient: ['#090B60', '#e0e4e9'],
    };
    let rect6 = {
      type: 'rect',
      x: 0, y: 0, w: 500, h: 32,
      linearGradient: ['#090B60', '#e0e4e9'],
    };

    const docDefinition = {
      info: {
        title: 'Configuration',
      },
      background: {
        image: img2,
        width: 600,
        absolutePosition: { x: 0, y: 0 },
      },
      content: [
        {
          image: img,
          width: 120,
          margin: [0, 0, 0, 0], // [left, top, right, bottom]
        },
        /*----------------------------------------------------------------------------------------*/
        {
          image: img3,
          width: 180,
          absolutePosition: { x: 380, y: 80 },
        },
        /*----------------------------------------------------------------------------------------*/
        {
          text: 'Build Summary',
          style: 'Header',
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 5],
          color: '#090B60',
          alignment: 'center'
        },
        {
          stack: [
            {
              canvas: [rect]
            },
            {
              columns: [
                {
                  width: rect.w,
                  noWrap: false,
                  maxHeight: rect.h,
                  text: this.vc_name,
                  color: 'white',
                  fontSize: 14,
                  margin: [8, 8, 0, 6]
                }
              ],
              relativePosition: {
                x: rect.x,
                y: - rect.h
              },
              margin: [0, 0, 0, 10] // [left, top, right, bottom]
            }
          ]
        },
        {
          table: {
            widths: [100, 'auto'],
            body: [
              [{ text: 'Configuration ID : ', bold: true }, { text: this.configurator_id }],
              [{ text: 'Mobile Number :', bold: true }, { text: 'Not Available' }],
              // [{  text: 'Mobile Number :', bold: true }, { text: this.userData.mobile_number}], //for osp team
              [{ text: 'Date & Time :', bold: true }, { text: full_date }]
            ]
          },
          layout: 'noBorders',
          margin: [0, 0, 0, 20] // [left, top, right, bottom]
        },
        /*----------------------------------------------------------------------------------------*/
        {
          canvas: [
            {
              lineColor: "#147DF0",
              lineWidth: 2,
              type: "line",
              x1: 0, x2: 500, y1: 0, y2: 0,
            }
          ],
          margin: [0, 0, 0, 5]
        },
        {
          stack: [
            {
              canvas: [rect2]
            },
            {
              columns: [
                {
                  width: rect2.w,
                  noWrap: false,
                  maxHeight: rect2.h,
                  text: 'Configuration Details',
                  color: 'white',
                  fontSize: 14,
                  margin: [8, 8, 0, 6]
                }
              ],
              relativePosition: {
                x: rect2.x,
                y: - rect2.h
              },
              margin: [0, 0, 0, 0] // [left, top, right, bottom]
            }
          ]
        },
        {
          layout: 'lightHorizontalLines', // optional
          table: {
            widths: [170, 310],
            body: [
              [{ text: '' }, { text: '' }],
              ...data.map((result: { title: any; value: any; }) => ([result.title, result.value]))
            ]
          },
          margin: [0, 0, 0, 20],
        },
        /*----------------------------------------------------------------------------------------*/
        {
          canvas: [
            {
              lineColor: "#147DF0",
              lineWidth: 2,
              type: "line",
              x1: 0, x2: 500, y1: 0, y2: 0,
            }
          ],
          margin: [0, 0, 0, 5]
        },
        {
          stack: [
            {
              canvas: [rect3]
            },
            {
              columns: [
                {
                  width: rect3.w,
                  noWrap: false,
                  maxHeight: rect3.h,
                  text: 'Value Added Services Details',
                  color: 'white',
                  fontSize: 14,
                  margin: [8, 8, 0, 6]
                }
              ],
              relativePosition: {
                x: rect3.x,
                y: - rect3.h
              },
              margin: [0, 0, 0, 0] // [left, top, right, bottom]
            }
          ]
        },
        {
          layout: 'lightHorizontalLines', // optional
          table: {
            headerRows: 0,
            widths: [170, 310],
            body: [
              [{ text: '' }, { text: '' }],
              ...data2.map((result: { title: any; value: any; }) => ([result.title, result.value]))
            ]
          },
          margin: [0, 0, 0, 20],
        },
        /*----------------------------------------------------------------------------------------*/
        {
          canvas: [
            {
              lineColor: "#147DF0",
              lineWidth: 2,
              type: "line",
              x1: 0, x2: 500, y1: 0, y2: 0,
            }
          ],
          margin: [0, 0, 0, 5]
        },
        {
          stack: [
            {
              canvas: [rect4]
            },
            {
              columns: [
                {
                  width: rect4.w,
                  noWrap: false,
                  maxHeight: rect4.h,
                  text: 'Configured Vehicle Details',
                  color: 'white',
                  fontSize: 14,
                  margin: [8, 8, 0, 6]
                }
              ],
              relativePosition: {
                x: rect4.x,
                y: - rect4.h
              },
              margin: [0, 0, 0, 0] // [left, top, right, bottom]
            }
          ]
        },
        {
          layout: 'lightHorizontalLines', // optional
          table: {
            headerRows: 1,
            widths: [170, 310],
            body: [
              [{ text: '' }, { text: '' }],
              ...data3.map((result: { title: any; value: any; }) => ([result.title, result.value]))
            ]
          },
          margin: [0, 0, 0, 20],
        },
        /*----------------------------------------------------------------------------------------*/
        {
          canvas: [
            {
              lineColor: "#147DF0",
              lineWidth: 2,
              type: "line",
              x1: 0, x2: 500, y1: 0, y2: 0,
            }
          ],
          margin: [0, 0, 0, 5]
        },
        {
          stack: [
            {
              canvas: [rect5]
            },
            {
              columns: [
                {
                  width: rect5.w,
                  noWrap: false,
                  maxHeight: rect5.h,
                  text: 'Price Details',
                  color: 'white',
                  fontSize: 14,
                  margin: [8, 8, 0, 6]
                }
              ],
              relativePosition: {
                x: rect5.x,
                y: - rect5.h
              },
              margin: [0, 0, 0, 0] // [left, top, right, bottom]
            }
          ]
        },
        {
          layout: 'lightHorizontalLines', // optional
          table: {
            headerRows: 1,
            widths: [170, 310],
            body: [
              [{ text: '' }, { text: '' }],
              ...data4.map((result: { title: any; value: any; }) => ([result.title, result.value]))
            ]
          },
          margin: [0, 0, 0, 20],
        },
        /*----------------------------------------------------------------------------------------*/
        {
          canvas: [
            {
              lineColor: "#147DF0",
              lineWidth: 2,
              type: "line",
              x1: 0, x2: 500, y1: 0, y2: 0,
            }
          ],
          margin: [0, 0, 0, 5]
        },
        {
          stack: [
            {
              canvas: [rect6]
            },
            {
              columns: [
                {
                  width: rect6.w,
                  noWrap: false,
                  maxHeight: rect6.h,
                  text: 'Disclaimer',
                  color: 'white',
                  fontSize: 14,
                  margin: [8, 8, 0, 6]
                }
              ],
              relativePosition: {
                x: rect6.x,
                y: - rect6.h
              },
              margin: [0, 0, 0, 10] // [left, top, right, bottom]
            }
          ]
        },
        {
          nodeName: "TABLE",
          marginBottom: 5,
          style: ["html-table"],
          layout: 'noBorders',
          table:
          {
            body: [
              [
                {
                  text: "•",
                  nodeName: "TD",
                  style: ["html-td", "html-tr", "html-tbody", "html-table"]
                },
                {
                  text: "Prices shown are Ex Showroom. Final offer price will be given by Dealer.",
                  nodeName: "TD",
                  style: ["html-td", "html-tr", "html-tbody", "html-table"]
                }
              ],
              [
                {
                  text: "•",
                  nodeName: "TD",
                  style: ["html-td", "html-tr", "html-tbody", "html-table"]
                },
                {
                  text: "Images, video used in the configurator are representational and may differ in actual vehicle. The illustrations may also include accessories and optional extras that are not included in the standard specification and are out of the scope of delivery.",
                  nodeName: "TD",
                  style: ["html-td", "html-tr", "html-tbody", "html-table"]
                }
              ],
              [
                {
                  text: "•",
                  nodeName: "TD",
                  style: ["html-td", "html-tr", "html-tbody", "html-table"]
                },
                {
                  text: "For more details or clarifications, please reach out to your nearest dealership or contact us at toll free no. cac@tatamotors.com 1800 209 7979.",
                  nodeName: "TD",
                  style: ["html-td", "html-tr", "html-tbody", "html-table"]
                }
              ],
              [
                {
                  text: "•",
                  nodeName: "TD",
                  style: ["html-td", "html-tr", "html-tbody", "html-table"]
                },
                {
                  text: "Annual maintenance contract packages are available as per applicability to selected product segment.",
                  nodeName: "TD",
                  style: ["html-td", "html-tr", "html-tbody", "html-table"]
                }
              ]
            ]
          }
        }
        /*----------------------------------------------------------------------------------------*/
      ]
    };
    return docDefinition
  }

  async pdfdata_without_VAS(img: any, data: any, data3: any, data4: any, full_date: any, img2: any, img3: any) {
    let rect = {
      type: 'rect',
      x: 0, y: 0, w: 250, h: 32,
      linearGradient: ['#090B60', '#ffffff'],
    };
    let rect2 = {
      type: 'rect',
      x: 0, y: 0, w: 500, h: 32,
      linearGradient: ['#090B60', '#e0e4e9'],
    };
    let rect4 = {
      type: 'rect',
      x: 0, y: 0, w: 500, h: 32,
      linearGradient: ['#090B60', '#e0e4e9'],
    };
    let rect5 = {
      type: 'rect',
      x: 0, y: 0, w: 500, h: 32,
      linearGradient: ['#090B60', '#e0e4e9'],
    };
    let rect6 = {
      type: 'rect',
      x: 0, y: 0, w: 500, h: 32,
      linearGradient: ['#090B60', '#e0e4e9'],
    };
    const docDefinition = {
      info: {
        title: 'Configuration',
      },
      background: {
        image: img2,
        width: 600,
        absolutePosition: { x: 0, y: 0 },
      },
      content: [
        {
          image: img,
          width: 120,
          margin: [0, 0, 0, 0], // [left, top, right, bottom]
        },
        /*----------------------------------------------------------------------------------------*/
        {
          image: img3,
          width: 180,
          absolutePosition: { x: 380, y: 80 },
        },
        /*----------------------------------------------------------------------------------------*/
        {
          text: 'Build Summary',
          style: 'Header',
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 5],
          color: '#090B60',
          alignment: 'center'
        },
        {
          stack: [
            {
              canvas: [rect]
            },
            {
              columns: [
                {
                  width: rect.w,
                  noWrap: false,
                  maxHeight: rect.h,
                  text: this.vc_name,
                  color: 'white',
                  fontSize: 14,
                  margin: [8, 8, 0, 6]
                }
              ],
              relativePosition: {
                x: rect.x,
                y: - rect.h
              },
              margin: [0, 0, 0, 10] // [left, top, right, bottom]
            }
          ]
        },
        {
          table: {
            widths: [100, 'auto'],
            body: [
              [{ text: 'Configuration ID : ', bold: true }, { text: this.configurator_id }],
              [{ text: 'Mobile Number :', bold: true }, { text: 'Not Available' }],
              //[{  text: 'Mobile Number :', bold: true }, { text: this.userData.mobile_number}], //for osp team
              [{ text: 'Date & Time :', bold: true }, { text: full_date }]
            ]
          },
          layout: 'noBorders',
          margin: [0, 0, 0, 20] // [left, top, right, bottom]
        },
        /*----------------------------------------------------------------------------------------*/
        {
          canvas: [
            {
              lineColor: "#147DF0",
              lineWidth: 2,
              type: "line",
              x1: 0, x2: 500, y1: 0, y2: 0,
            }
          ],
          margin: [0, 0, 0, 5]
        },
        {
          stack: [
            {
              canvas: [rect2]
            },
            {
              columns: [
                {
                  width: rect2.w,
                  noWrap: false,
                  maxHeight: rect2.h,
                  text: 'Configuration Details',
                  color: 'white',
                  fontSize: 14,
                  margin: [8, 8, 0, 6]
                }
              ],
              relativePosition: {
                x: rect2.x,
                y: - rect2.h
              },
              margin: [0, 0, 0, 0] // [left, top, right, bottom]
            }
          ]
        },
        {
          layout: 'lightHorizontalLines', // optional
          table: {
            headerRows: 0,
            widths: [170, 310],
            body: [
              [{ text: '' }, { text: '' }],
              ...data.map((result: { title: any; value: any; }) => ([result.title, result.value]))
            ]
          },
          margin: [0, 0, 0, 20],
        },
        /*----------------------------------------------------------------------------------------*/
        {
          canvas: [
            {
              lineColor: "#147DF0",
              lineWidth: 2,
              type: "line",
              x1: 0, x2: 500, y1: 0, y2: 0,
            }
          ],
          margin: [0, 0, 0, 5]
        },
        {
          stack: [
            {
              canvas: [rect4]
            },
            {
              columns: [
                {
                  width: rect4.w,
                  noWrap: false,
                  maxHeight: rect4.h,
                  text: 'Configured Vehicle Details',
                  color: 'white',
                  fontSize: 14,
                  margin: [8, 8, 0, 6]
                }
              ],
              relativePosition: {
                x: rect4.x,
                y: - rect4.h
              },
              margin: [0, 0, 0, 0] // [left, top, right, bottom]
            }
          ]
        },
        {
          layout: 'lightHorizontalLines', // optional
          table: {
            headerRows: 1,
            widths: [170, 310],
            body: [
              [{ text: '' }, { text: '' }],
              ...data3.map((result: { title: any; value: any; }) => ([result.title, result.value]))
            ]
          },
          margin: [0, 0, 0, 20],
        },
        /*----------------------------------------------------------------------------------------*/
        {
          canvas: [
            {
              lineColor: "#147DF0",
              lineWidth: 2,
              type: "line",
              x1: 0, x2: 500, y1: 0, y2: 0,
            }
          ],
          margin: [0, 0, 0, 5]
        },
        {
          stack: [
            {
              canvas: [rect5]
            },
            {
              columns: [
                {
                  width: rect5.w,
                  noWrap: false,
                  maxHeight: rect5.h,
                  text: 'Price Details',
                  color: 'white',
                  fontSize: 14,
                  margin: [8, 8, 0, 6]
                }
              ],
              relativePosition: {
                x: rect5.x,
                y: - rect5.h
              },
              margin: [0, 0, 0, 0] // [left, top, right, bottom]
            }
          ]
        },
        {
          layout: 'lightHorizontalLines', // optional
          table: {
            headerRows: 1,
            widths: [170, 310],
            body: [
              [{ text: '' }, { text: '' }],
              ...data4.map((result: { title: any; value: any; }) => ([result.title, result.value]))
            ]
          },
          margin: [0, 0, 0, 20],
        },
        /*----------------------------------------------------------------------------------------*/
        {
          canvas: [
            {
              lineColor: "#147DF0",
              lineWidth: 2,
              type: "line",
              x1: 0, x2: 500, y1: 0, y2: 0,
            }
          ],
          margin: [0, 0, 0, 5]
        },
        {
          stack: [
            {
              canvas: [rect6]
            },
            {
              columns: [
                {
                  width: rect6.w,
                  noWrap: false,
                  maxHeight: rect6.h,
                  text: 'Disclaimer',
                  color: 'white',
                  fontSize: 14,
                  margin: [8, 8, 0, 6]
                }
              ],
              relativePosition: {
                x: rect6.x,
                y: - rect6.h
              },
              margin: [0, 0, 0, 10] // [left, top, right, bottom]
            }
          ]
        },
        {
          nodeName: "TABLE",
          marginBottom: 5,
          style: ["html-table"],
          layout: 'noBorders',
          table:
          {
            body: [
              [
                {
                  text: "•",
                  nodeName: "TD",
                  style: ["html-td", "html-tr", "html-tbody", "html-table"]
                },
                {
                  text: "Prices shown are Ex Showroom. Final offer price will be given by Dealer.",
                  nodeName: "TD",
                  style: ["html-td", "html-tr", "html-tbody", "html-table"]
                }
              ],
              [
                {
                  text: "•",
                  nodeName: "TD",
                  style: ["html-td", "html-tr", "html-tbody", "html-table"]
                },
                {
                  text: "Images, video used in the configurator are representational and may differ in actual vehicle. The illustrations may also include accessories and optional extras that are not included in the standard specification and are out of the scope of delivery.",
                  nodeName: "TD",
                  style: ["html-td", "html-tr", "html-tbody", "html-table"]
                }
              ],
              [
                {
                  text: "•",
                  nodeName: "TD",
                  style: ["html-td", "html-tr", "html-tbody", "html-table"]
                },
                {
                  text: "For more details or clarifications, please reach out to your nearest dealership or contact us at toll free no. cac@tatamotors.com 1800 209 7979.",
                  nodeName: "TD",
                  style: ["html-td", "html-tr", "html-tbody", "html-table"]
                }
              ],
              [
                {
                  text: "•",
                  nodeName: "TD",
                  style: ["html-td", "html-tr", "html-tbody", "html-table"]
                },
                {
                  text: "Annual maintenance contract packages are available as per applicability to selected product segment.",
                  nodeName: "TD",
                  style: ["html-td", "html-tr", "html-tbody", "html-table"]
                }
              ]
            ]
          }
        }
        /*----------------------------------------------------------------------------------------*/
      ]
    };
    return docDefinition
  }

  getBase64ImageFromURL(url: any) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        let ctx: any = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = error => {
        resolve("invalid");
      };
      img.src = url;
    });
  }

  async addToWishlist() {
    let payload: any = {}
    let vc_number: any = ""
    let state = await lastValueFrom(this.store.pipe(select(getAllState), take(1)));
    let data: any = state.stepBarState.stepArr
    const {isPredictiveTab,pred_vc_no} = await this._dataLobService.extractRouteData()

    let selectedLob = state.stepBarState.selectedConfLob

    // var currentStateArr = state.stepBarState.stepArr;
    let otherDetails = state.stepBarState.lobVehicleData.vehLxData

    let additionFeaturePageNo = data.findIndex((step: any) => step.title === "Additional Features");
    let comfort_select = "";
    if (additionFeaturePageNo > 0) {
      comfort_select = state.stepBarState.stepArr[additionFeaturePageNo].value
    }

    payload["action_type"] = "add"
    if(isPredictiveTab){
      payload["vc_number"] = [pred_vc_no]
    }
    else if (comfort_select == 'Selected' && (selectedLob == 'hcv' || selectedLob == 'ilmcv')) {
      payload["vc_number"] = [otherDetails.vc_no]
    } else {
      let index = data.findIndex((x: { title: string; }) => x.title === 'Base Vehicle');
      vc_number = data[index].other
      /*====================================================================================*/
      payload["vc_number"] = [vc_number];
    }



    this.ospWishlistApi = this._dataLobService.ospApiCall("wishlist", payload).subscribe(async (result: any) => {
      if (result.success) {
        this.toaster.success(result.data.msg)
      } else {
        this.toaster.warning(result.data.msg)
      }
    })
  }

  routeToTml() {
    // Converts the route into a string that can be used
    // with the window.open() function

    window.open("https://www.tatamotors.com/", "_blank");
  }
}

/*
*/
